import styled from 'styled-components';
import TransitioningModal from '../../../../components/Modals/TransitioningModal';
import { BACKGROUND_COLOR } from '../../../../constants';
import { CloseButton, StickiedTopPart } from './CommonInShowAllStylesModal';
import useGetCommunityStyles from '../../../../hooks/images/useGetCommunityStyles';
import { useEffect, useState } from 'react';
import { CommunityStyle, StyleInterface } from '../../../../types';
import { StyleCard, StyleName } from '../StyleCardParts';
import { waitSeconds } from '../../../../components/helpers';
import { useImageGenerationSettingsContext } from '../../../../context/ImageGenerationSettingsProvider';

interface BrowseCommunityStylesModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
  handleChooseStyle?: (style: StyleInterface) => void;
}

const BrowseCommunityStylesModal = ({
  show,
  setShow,
  handleChooseStyle,
}: BrowseCommunityStylesModalProps) => {
  const closeModal = () => setShow(false);
  const getCommunityStyles = useGetCommunityStyles();
  const { selectedStyle } = useImageGenerationSettingsContext();

  const [bestStyles, setBestStyles] = useState<CommunityStyle[]>([]);

  useEffect(() => {
    const fetchBestStyles = async () => {
      const styles = await getCommunityStyles();
      const first30Styles = styles.slice(0, 30);
      setBestStyles(first30Styles);
    };
    fetchBestStyles();
  }, []);

  useEffect(() => {
    const fetchStyles = async () => {
      const styles = await getCommunityStyles();
      console.log(styles);
    };
    if (show) {
      fetchStyles();
    }
  }, [show]);

  const handleClickStyle = async (style: StyleInterface) => {
    if (handleChooseStyle) {
      handleChooseStyle(style);
    }
    await waitSeconds(0.3);
    closeModal();
  };

  return (
    <TransitioningModal
      isOpen={show}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 300,
          height: '100%',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },
        content: {
          backgroundColor: BACKGROUND_COLOR,
          padding: '16px',
          paddingTop: 0,
          width: '100%',
          height: '90%',
          marginTop: '-40px',
          maxWidth: '800px',
          minHeight: '300px',
          overflowY: 'scroll',
        },
      }}
      ariaHideApp={false}
      shouldFocusAfterRender={false}
      onRequestClose={closeModal}
    >
      <StickiedTopPart>
        <ModalTitle>Browse Community Styles</ModalTitle>
        <CloseButton onClick={closeModal} />
      </StickiedTopPart>

      <ContentContainer>
        <SectionTitle>Popular Styles</SectionTitle>
        <StylesGrid>
          {bestStyles.map((communityStyle) => (
            <CommunityStyleCard 
              key={communityStyle.style.id}
              communityStyle={communityStyle}
              isSelected={selectedStyle.id === communityStyle.style.id}
              onClick={() => handleClickStyle(communityStyle.style)}
            />
          ))}
          <EmptyDiv />
        </StylesGrid>
      </ContentContainer>
    </TransitioningModal>
  );
};

interface CommunityStyleCardProps {
  communityStyle: CommunityStyle;
  isSelected: boolean;
  onClick: () => void;
}

const CommunityStyleCard: React.FC<CommunityStyleCardProps> = ({ 
  communityStyle, 
  isSelected,
  onClick 
}) => {
  return (
    <StyledCard 
      isSelected={isSelected}
      isInModal
      onClick={onClick}
      style={{ backgroundImage: `url(${communityStyle.imageUrlOfFirstImage})` }}
    >
      <CardContent>
        <StyleName>{communityStyle.style.name}</StyleName>
      </CardContent>
    </StyledCard>
  );
};

const ModalTitle = styled.h2`
  color: white;
  margin: 0;
  font-size: 1.5rem;
`;

const ContentContainer = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const SectionTitle = styled.h3`
  color: white;
  margin: 0;
  font-size: 1.2rem;
  margin-bottom: 12px;
`;

const StylesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 16px;
`;

const StyledCard = styled(StyleCard)`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background-size: cover;
  background-position: center;
  transition: transform 0.2s ease;
  
  &:hover {
    transform: translateY(-3px);
  }
`;

const CardContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const UsageCount = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  font-size: 12px;
  text-align: center;
  padding: 2px 0;
`;

const EmptyDiv = styled.div`
  height: 50px;
`;

export default BrowseCommunityStylesModal;
